import { FuneralService } from '../../../../types';
import { ServiceSheetButton } from '../../Shared/ServiceSheetButton';
import ServiceAdditionalLinks from './ServiceAdditionalLinks';
import ServiceEvents from './ServiceEvents';

export const ServiceDetails = ({ service, timezone }: { service: FuneralService; timezone: string }) => {
  return (
    <div>
      <ServiceEvents events={service?.events} service={service} timezone={timezone} />
      <div className="details-container">
        <div className="main-details">
          <div className="service-description" dangerouslySetInnerHTML={{ __html: service?.description ?? '' }} />
          {service?.service_sheet_link && <ServiceSheetButton link={service?.service_sheet_link} />}
          <ServiceAdditionalLinks additionalLinks={service?.additional_links} />
        </div>
        {service?.profile_photo_url ? (
          <img className="details-image" src={service?.profile_photo_url} alt={service?.name} />
        ) : (
          <div className="no-image"></div>
        )}
      </div>
    </div>
  );
};
